<template>
  <div >
      <ag-charts-vue :options="options"
      :style="styleHeight"
      ></ag-charts-vue>
  </div>
</template>

<script setup>

  import { useConnectionStore } from '@/stores/connectionStore';
  import { AgChartsVue } from 'ag-charts-vue3';
 
  import { ref , onMounted } from 'vue'
  import { watch } from 'vue'
  import { computed } from "@vue/reactivity"
  import { t } from "@/composables/translateText.js";

  const connectionStore = useConnectionStore()
  const isDark = ref(connectionStore.getDarkmode != "light")
  //const isDark = ref(window.matchMedia('(prefers-color-scheme: dark)'))

  const props = defineProps({
    moveList : {
        type : Array,
        default : []
    },
    moveListTrigger : {
        type : Number,
        default : 0
    },
    moveNumber : {
      type : Number,
      default : 15
    },
    showAdvantage : {
      type : Boolean,
      default : false
    },
    styleHeight : {
      type : String,
      default :  "style= 'height: 500px'" 
    }
    
  })

  const options = ref({
      theme: {
        baseTheme: (isDark.value) ? 'ag-default-dark' : 'ag-default',
        overrides: {
          column: {
            axes: {
              category: {
                groupPaddingInner: 0,
              },
            },
          },
        },
      },
      /*
      title: {
        text: "Games before Move 15",
      },
      subtitle: {
        text: 'Percentage in Each 1 point Stockfish score bucket',
      },
      */
      data: [],
      series: [],
    })

    var graphType = "raw"

    const moveListTrigger = computed({
     get() {
       return props.moveListTrigger
     }
   })

   const styleHeight = computed({
    get() {
      return props.styleHeight
    }
  })

  function findSanInList(san) {
    for (var i=0; i < props.moveList.length; i++)
      if (props.moveList[i].san == san)
        return (i)
    return (-1)
  }

  watch(moveListTrigger, (newVal,oldVal) => {
    //console.log("**** MOVE NUMBER in trigger",props.moveNumber)
    //console.log("**** MOVES",props.moveList)
    const copyOptions = JSON.parse(JSON.stringify(options.value));
    //console.log("MOVE LIST TRIGGER", options.value.data[1])

    graphType = (props.showAdvantage) ? "white" : "raw"
    var buckets = []
    switch (graphType) {
      case "raw" :
        buckets = ["B#","B--","-5","-4","-3","-2","-1","=",
            "+1","+2","+3","+4","+5","W++","W#"]
        break
      case "white" :
        buckets = ["+1","+2","+3","+4","+5","> +5.5",t("White Win")]
        break
      case "black" :
        buckets = ["-1","-2","-3","-4","-5","> -5.5",t("Black Win")]
        break
    }
 
    const moveOffset = (Number(props.moveNumber) - 9) / 3

    const totalIndex = findSanInList("total")

    // setup the "series"
    copyOptions.series = []
    copyOptions.data = []

    for (var i=0; i < buckets.length; i++) {
        copyOptions.data[i] = {}
        copyOptions.data[i]["bucket"] = buckets[i] 
    }
    
    //console.log("******* TOTAL OFFSET ",totalIndex)
    for (var moveIndex = 0; moveIndex < props.moveList.length; moveIndex++) {
      //console.log("move on slice dice graph",moveIndex,props.moveList[moveIndex])
      if (props.moveList[moveIndex].selected == false)
        continue
        
      const san = props.moveList[moveIndex].san

      copyOptions.series.push( { type : 'bar', xKey : 'bucket', 'yKey' : san , 'yName' : san})

      for (var i=0; i < buckets.length; i++) {
        switch (graphType) {
          case "raw" :
            if (props.moveList[moveIndex].moves.length > 0)
              copyOptions.data[i][san] = props.moveList[moveIndex].moves[moveOffset][i] 
            break
          case "white" :
              copyOptions.data[i][san] = props.moveList[moveIndex].moves[moveOffset][i+8] 
                - props.moveList[moveIndex].moves[moveOffset][6-i]
            break
          case "black" :
            copyOptions.data[i][san] = -props.moveList[moveIndex].moves[moveOffset][i+8] 
              + props.moveList[moveIndex].moves[moveOffset][6-i]
            break
        }
      }
    }
 
    //console.log("copy options",copyOptions)
    //copyOptions.data[0].e4 = 62
    options.value = copyOptions
   
  })

</script>

<style scoped>

</style>
